'use strict';

module.exports = {
	init: function init(options) {
		if (options && typeof window !== 'undefined') {
			var dataLayer = window.dataLayer || {};
			if (options.start) {
				dataLayer.dataTrack = 'Start';
			}
			if (options.finish) {
				dataLayer.dataTrack = 'Finish';
				dataLayer.mpuid = options.cust + ';;;;;' + options.page + ';;;;;';
			}
			if (options.start || options.finish) {
				dataLayer.customerType = 'Customer';
				dataLayer.sessionType = 'Customer';
				dataLayer.pageType = 'Customer';
				dataLayer.contentCountry = options.country;
				dataLayer.contentLanguage = options.language;
				dataLayer.localTimeZone = '';
				dataLayer.localTime = (new Date()).toString();
				dataLayer.FptiId = options.fptiGuid;
				dataLayer.gaCid = '';
				dataLayer.gaUid = '';
				dataLayer.flowType = 'Organic';
				window.dataLayer = dataLayer;
				options.url = options.url || '//www.paypalobjects.com/tagmgmt/bootstrap.js';
				(function(i,s,o,g,r,a,m){i['tagManagerObject']=r;i[r]=i[r]||function(){
						(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
					m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
				})(window, document, 'script', options.url, 'tagManager');
			}
		}
	}
};


/** WEBPACK FOOTER **
 ** ./src/lib/tagManager.js
 **/